import { createFileRoute, Outlet } from "@tanstack/react-router"
import { BackofficeKnowledge } from "modules/backoffice/components/knowledge"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { BackofficeKnowledgeFiltersSchema, TimeFrameEnum, TimeFrameSchema } from "schema"
import { z } from "zod"

const SearchSchema = BackofficeKnowledgeFiltersSchema.extend({
  timeFrame: TimeFrameSchema.default(TimeFrameEnum.Last1Week),
  companyId: z.string().optional(),
})

export const Route = createFileRoute("/_base/_auth/backoffice/knowledge")({
  component: () => (
    <>
      <BackofficeKnowledge />
      <Outlet />
    </>
  ),
  validateSearch: (search: Partial<z.input<typeof SearchSchema>>) => SearchSchema.parse(search),
  loader: ({ route: { fullPath } }) =>
    new Crumb({
      fullPath,
      title: (t) => t("backoffice.knowledge.title"),
    }),
})
